function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}
function debounce(fn, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };
}
if (!customElements.get('collection-tabs')) {
    customElements.define('collection-tabs', class CollectionTabs extends HTMLElement {
        constructor() {
            super();
            this.sectionId = this.dataset.sectionId;
            // Properly bind the event listener
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout( () => {
                    this.init()
                }, 1500)
            });
        }

        async init() {
            console.log("Start loading")
            try {
                if (!this.sectionId) {
                    throw new Error('Section ID is missing');
                }

                const response = await fetch(`${window.location.pathname}?view=all-tabs&section_id=${this.sectionId}`);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const responseText = await response.text();
                const doc = new DOMParser().parseFromString(responseText, 'text/html');

                const fetchProductBlocks = doc.querySelectorAll('.tabs-slider-product-slider .swiper-wrapper');
                const productBlocks = this.querySelectorAll('.tabs-slider-product-slider .swiper-wrapper');

                if (!productBlocks.length || !fetchProductBlocks.length) {
                    throw new Error('Product blocks not found');
                }

                productBlocks.forEach((element, index) => {
                    if (index !== 0 && fetchProductBlocks[index]) {
                        element.innerHTML = fetchProductBlocks[index].innerHTML;
                    }
                });

            } catch (error) {
                console.error('Failed to initialize collection tabs:', error.message);
            }
        }
    });
}

//block submit default form login
document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('form.js-form, .account-form.js-form');

    // Form validation module
    var FormValidator = function () {
        function FormValidator(formElementOrSelector) {
            if (!formElementOrSelector) return;

            this.form = typeof formElementOrSelector === 'string'
                ? document.querySelector(formElementOrSelector)
                : formElementOrSelector;

            if (!this.form) return;

            this.fields = Array.from(this.form.querySelectorAll('.js-form-field'));
            this.upload_files = [];
            this.bindEvents();
            this.initUploads();
        }

        FormValidator.prototype.bindEvents = function () {
            var _this = this;
            this.form.addEventListener('submit', function (e) {
                return _this.handleSubmit(e);
            });
        };

        FormValidator.prototype.handleSubmit = function (e) {
            if (!this.validateAllFields()) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        };

        FormValidator.prototype.validateAllFields = function () {
            return this.fields.map(field => this.validateField(field)).every(Boolean);
        };

        FormValidator.prototype.validateField = function (field) {
            const input = field.querySelector('.js-form-input');
            const error = field.querySelector('.js-form-field-error');
            const value = input?.value?.trim();
            this.resetFieldState(field, input, error);

            const isPassword = input?.name === 'customer[password]';
            const isConfirm = input?.name === 'customer[password_confirmation]';
            const passwordInput = this.form.querySelector('input[name="customer[password]"]');
            const confirmInput = this.form.querySelector('input[name="customer[password_confirmation]"]');

            const formHasPasswordFields = passwordInput && confirmInput;

            // Якщо форма має обидва поля - робимо спеціальну перевірку
            if (formHasPasswordFields && (isPassword || isConfirm)) {
                const password = passwordInput?.value?.trim();
                const confirm = confirmInput?.value?.trim();

                if (isPassword) {
                    const patternAttr = input.dataset.pattern;
                    const pattern = patternAttr ? new RegExp(patternAttr) : null;
                    const patternError = input.dataset.error;

                    if (pattern && !pattern.test(password)) {
                        field.classList.add('_error');
                        input.classList.add('_error');
                        if (error && patternError) {
                            this.showError(error, patternError);
                        }
                        return false;
                    }
                }

                if (isConfirm && password !== confirm) {
                    const confirmErrorText = input.dataset.errorConfirm;
                    field.classList.add('_error');
                    input.classList.add('_error');
                    if (error && confirmErrorText) {
                        this.showError(error, confirmErrorText);
                    }
                    return false;
                }

                // Якщо все добре
                return true;
            }

            // Файли
            if (input?.type === 'file') {
                const hasFiles = this.upload_files.length > 0;
                return hasFiles || this.handleEmptyField(field, input, error);
            }

            // Порожні поля
            return value ? this.validatePattern(field, input, error, value) : this.handleEmptyField(field, input, error);
        };

        FormValidator.prototype.resetFieldState = function (field, input, error) {
            field.classList.remove('_error');
            input?.classList.remove('_error');
            if (error) error.textContent = '';
        };

        FormValidator.prototype.handleEmptyField = function (field, input, error) {
            const emptyError = field.dataset.emptyError;
            if (!emptyError) return true;

            field.classList.add('_error');
            input.classList.add('_error');
            if (error) this.showError(error, emptyError);
            return false;
        };

        FormValidator.prototype.validatePattern = function (field, input, error, value) {
            const patternAttr = input.dataset.pattern;
            if (!patternAttr) return true;

            const pattern = new RegExp(patternAttr);
            const patternError = field.dataset.patternError;
            if (!pattern.test(value)) {
                input.classList.add('_error');
                if (error && patternError) this.showError(error, patternError);
                return false;
            }

            return true;
        };

        FormValidator.prototype.showError = function (errorElement, errorMessage) {
            errorElement.textContent = errorMessage;
            errorElement.style.display = 'block';
        };

        FormValidator.prototype.initUploads = function () {
            const _this = this;
            const uploads = document.querySelectorAll('.form-uploader');
            const events = ['dragenter', 'dragover', 'dragleave', 'drop'];

            uploads.forEach(upload => {
                const input = upload.querySelector('input[type="file"]');
                events.forEach(event => {
                    upload.addEventListener(event, e => {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                });

                upload.addEventListener('drop', e => {
                    _this.uploadFiles(upload, e.dataTransfer.files);
                });

                input.addEventListener('change', e => {
                    _this.uploadFiles(upload, input.files);
                }, { passive: true });
            });
        };

        FormValidator.prototype.uploadFiles = function (upload, files) {
            const validatedFiles = this.validationFiles(Array.from(files));
            validatedFiles.forEach(file => this.uploadFile(upload, file));
        };

        FormValidator.prototype.uploadFile = function (upload, file) {
            const list = upload.querySelector('.form-uploader-files');
            const input = upload.querySelector('input[name="files"]');

            const el = document.createElement('div');
            el.classList.add('file');

            const elImage = document.createElement('div');
            elImage.classList.add('file-image');

            const elImageFile = document.createElement('img');
            elImageFile.src = URL.createObjectURL(file);

            const elRemove = document.createElement('div');
            elRemove.classList.add('file-remove');
            elRemove.innerHTML = '<span class="icon icon-trash-2"></span>';

            elImage.appendChild(elImageFile);
            el.appendChild(elImage);
            el.appendChild(elRemove);
            list.appendChild(el);

            this.upload_files.push(file.name);
            input.value = this.upload_files.join(' ');

            elRemove.addEventListener('click', () => {
                el.remove();
                const index = this.upload_files.indexOf(file.name);
                if (index >= 0) this.upload_files.splice(index, 1);
                input.value = this.upload_files.join(' ');
            });
        };

        FormValidator.prototype.validationFiles = function (files) {
            const extensions = ['jpeg', 'jpg', 'png', 'JPEG', 'JPG', 'PNG'];
            const maxSize = 5; // MB
            const maxFiles = 10;

            const validatedFiles = [];

            files.forEach(file => {
                const extension = file.name.split('.').pop();
                const size = file.size / (1000 * 1000);
                if (extensions.includes(extension) && size <= maxSize) {
                    validatedFiles.push(file);
                    const errorEl = this.form.querySelector('.form-uploader-error');
                    if (errorEl) errorEl.style.display = 'none';
                } else if (size > maxSize) {
                    this.showFileError(file.name);
                }
            });

            return validatedFiles.slice(0, maxFiles);
        };

        FormValidator.prototype.showFileError = function (name) {
            const errorEl = this.form.querySelector('.form-uploader-error');
            if (errorEl) {
                errorEl.querySelector('.name').textContent = name;
                errorEl.style.display = 'block';
            }
        };

        return FormValidator;
    }();

    forms.forEach(form => {
        new FormValidator(form);
    });
});
//block submit default form login

if (!customElements.get('product-recommendation')) {
    customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
        constructor() {
            super();
            this.renderSection();
        }

        async renderSection() {
            try {
                const response = await fetch(this.dataset.url);
                const responseText = await response.text();
                const doc = new DOMParser().parseFromString(responseText, 'text/html');

                const fetchSection = doc.querySelector('[data-product-list]');
                const section = this.querySelector('[data-product-list]');

                if (fetchSection?.innerHTML.trim() && section) {
                    section.innerHTML = fetchSection.innerHTML;
                    this.removeAttribute('style');
                    this.initSlider();

                }

                if (window.lazyLoadEnabled === "true") {
                    reloadLazyLoad();
                }

            } catch (err) {
                console.error('Failed to load product recommendations:', err);
            }
        }

        initSlider() {
            var productsSwiper;
            var slider = this.querySelector('.products-slider-swiper');
            var btnPrev = this.querySelector('.swiper-button-prev');
            var btnNext = this.querySelector('.swiper-button-next');
            var scrollbar = slider.querySelector('.swiper-scrollbar');
            if (window.innerWidth >= 768) {
                 productsSwiper = new Swiper(slider, {
                    loop: false,
                    slidesPerView: 4,
                    spaceBetween: 14,
                    navigation: {nextEl: btnNext, prevEl: btnPrev},
                    scrollbar: {el: scrollbar, draggable: true, hide: false}
                })

            } else {
                if (productsSwiper) {
                    productsSwiper.destroy(true, true);
                    productsSwiper = null
                }
            }

        }
    });
}
async function updateCartCount() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cart = await response.json();
        const cartCountElements = document.querySelectorAll('[data-cart-count]');

        if (!cartCountElements.length) return;

        cartCountElements.forEach(element => {
            element.style.display = cart.item_count > 0 ? '' : 'none';
            element.textContent = cart.item_count;
        });
    } catch (error) {
        console.error('Failed to update cart count:', error);
    }
}
async function updateCartPopup() {
    try {
        const response = await fetch(`${window.routes.cart_url}?section_id=ajax-cart-popup`);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const elements = [
            {
                fetch: '.popup-content',
                current: '.popup-content',
                updateMethod: 'outerHTML'
            }
        ];

        elements.forEach(({fetch, current, updateMethod}) => {
            const fetchedElement = doc.querySelectorAll(fetch);
            const currentElement = document.querySelectorAll(current);

            fetchedElement.forEach((fetchEl, index) => {
                const currentEl = currentElement[index];
                if (fetchEl && currentEl) {
                    currentEl[updateMethod] = fetchEl[updateMethod];
                }
            });
        });
        updateCartPopupEvents();


        if (window.lazyLoadEnabled === "true") {
            reloadLazyLoad();
        }
    } catch (error) {
        console.error('Cart popup content update error:', error);
    }
}
function updateCartPopupEvents(){
    var quantityInput = document.querySelectorAll('popup-cart-item .quantity');
    if (quantityInput.length) {
        quantityInput.forEach(function (quantity) {
            var plus = quantity.querySelector('.quantity-button--plus');
            var minus = quantity.querySelector('.quantity-button--minus');
            var input = quantity.querySelector('.quantity-input');
            if (plus) {
                plus.addEventListener('click', function () {
                    var value = Number(input.value);
                    value++;
                    input.value = value;
                    if (value > 1) {
                        minus.classList.remove('_disabled')
                    }
                })
            }
            if (minus) {
                minus.addEventListener('click', function () {
                    var value = Number(input.value);
                    if (value > 1) {
                        value--;
                        input.value = value;
                        if (value == 1) {
                            minus.classList.add('_disabled')
                        }
                    }
                })
            }
        })
    }
    let popup = document.querySelector('#cart-popup');
    let popupClose = document.querySelector('#cart-popup .popup-close');
    popupClose?.addEventListener('click', function () {
        popup.classList.remove('open');
        popup.classList.remove('animation');
        unlockScrollbar()
    });
}


//init account
function initAccount(accountContainer) {
    const accountWrapper = accountContainer.querySelector('.account-wrapper');
    const sibling = accountWrapper?.nextElementSibling || accountWrapper?.previousElementSibling;
    const contentBlocks = accountContainer.querySelectorAll('.account-main');

    const outerMenu = document.querySelector('.account-menu'); // зовнішнє меню (з хешами)
    const innerMenu = accountWrapper.querySelector('.account-menu'); // меню в .account-wrapper
    const menuItems = innerMenu.querySelectorAll('.account-menu-item');

    function updateByHash(triggeredFrom = 'hashchange') {
        const hash = window.location.hash.replace('#', '');
        console.log(`[${triggeredFrom}] Хеш: #${hash}`);

        if (!hash) {
            console.log('Нема хешу: повертаємось до початкового стану');
            accountContainer.classList.remove('account');
            accountWrapper?.classList.add('hidden');
            sibling?.classList.remove('hidden');

            const accountElement = accountContainer.querySelector('.account');
            if (accountElement) accountElement.remove();

            return;
        }

        // Є хеш — переходимо до внутрішнього інтерфейсу
        accountContainer.classList.add('account');
        accountWrapper?.classList.remove('hidden');
        sibling?.classList.add('hidden');

        // Активуємо пункт меню
        let matched = false;

        menuItems.forEach(item => {
            const link = item.querySelector('a');
            const hrefHash = link?.getAttribute('href')?.split('#')[1];

            if (hrefHash === hash) {
                menuItems.forEach(i => i.classList.remove('_active'));
                item.classList.add('_active');
                matched = true;
            }else if( hash === 'cf-account-form' && hrefHash == 'customer-info' ) {
                item.classList.add('_active');
                matched = true;
            }
        });

        if (!matched) {
            // menuItems.forEach(i => i.classList.remove('_active'));
            // menuItems[0]?.classList.add('_active');
        }

        // Показуємо відповідний контент
        let foundTarget = false;
        contentBlocks.forEach((block, index) => {
            if (block.dataset.target === hash) {
                block.classList.remove('hidden');
                foundTarget = true;
            }else if( hash === 'cf-account-form' && block.dataset.target === "customer-info") {
                block.classList.remove('hidden');
                foundTarget = true;
            } else {
                block.classList.add('hidden');
            }

        });

        if (!foundTarget) {
            contentBlocks.forEach(block => {
                block.classList.add('hidden');
            });
        }
    }

    // При завантаженні
    if (window.location.hash) {
        updateByHash('load');
    }

    // Коли змінюється хеш
    window.addEventListener('hashchange', () => updateByHash('hashchange'));

    // Коли клікаємо по зовнішньому меню
    outerMenu?.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="#"]');
        if (!link) return;

        const hrefHash = link.getAttribute('href').split('#')[1];
        const currentHash = window.location.hash.replace('#', '');

        if (hrefHash === currentHash) {
            e.preventDefault();
            console.log(`[click] Такий самий хеш: ${hrefHash} — викликаємо вручну`);
            updateByHash('click');
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const accountContainer = document.querySelector('.account-container');
    if (accountContainer) {
        initAccount(accountContainer);
    }
    window.addEventListener('hashchange', function () {
        initAccount(accountContainer);
    });
});
//init account

//init login page
document.addEventListener('DOMContentLoaded', () => {
    const loginWrapper = document.querySelector('.login-wrapper');
    if (!loginWrapper) return;

    function handleHashChange(hash) {
        if (!hash.startsWith('#')) {
            hash = '#' + hash;
        }
        const hashValue = hash.slice(1);
        const allElements = document.querySelectorAll('[class*="hash-"]');

        allElements.forEach(el => {
            const classList = Array.from(el.classList);
            const isTarget = classList.some(cls => cls === `hash-${hashValue}`);
            if (isTarget) {
                el.classList.remove('hidden');
            } else {
                el.classList.add('hidden');
            }
        });
    }

    if (location.hash) {
        handleHashChange(location.hash);
    }

    window.addEventListener('hashchange', () => {
        handleHashChange(location.hash);
    });


});
//init login page

function onSwymLoadCallback(swat) {
    // Please make all SWYM-related API calls inside this function.
    // You can use the swat argument within this scope.
    if (swat) {
        console.log("Swym scripts tags are installed on your store");


        swat.evtLayer.addEventListener('sw:addedtowishlist', function (e){

            if(document.querySelectorAll(`.swym-heart[data-product-id="${e.detail.d.empi}"]`)){
                console.log("add")
                document.querySelectorAll(`.swym-heart[data-product-id="${e.detail.d.empi}"]`).forEach(button=>{
                    button.classList.add('swym-added')
                })
            }
        });
        swat.evtLayer.addEventListener('sw:removedfromwishlist', function (e){

            if(document.querySelectorAll(`.swym-heart[data-product-id="${e.detail.d.empi}"]`)) {
                document.querySelectorAll(`.swym-heart[data-product-id="${e.detail.d.empi}"]`).forEach(button => {
                    console.log("remove")
                    button.classList.remove('swym-added')
                    button.classList.remove('swym-adding')
                    button.classList.remove('swym-removing')
                })
            }
        });

    }
}
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

if (!customElements.get('share-button')) {
    customElements.define('share-button', class ShareButton extends HTMLElement {
        constructor() {
            super();
            this.button = this.querySelector('button');
            this.url = this.dataset.url || window.location.href;
            this.title = this.dataset.title || document.title;
            this.description = this.dataset.description || '';

            this.bindEvents();
        }

        bindEvents() {
	        console.log(navigator)
            if (!this.button || !navigator.share) return;

            this.button.addEventListener('click', () => this.handleShare());
        }

        async handleShare() {
            try {
                await navigator.share({
                    title: this.title,
                    text: this.description,
                    url: this.url
                });
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error sharing:', error);
                }
            }
        }
    });
}

document.body.addEventListener('click', async function(event) {
	const quickBuyButton = event.target.closest('[data-quick-buy-button]');
	if (!quickBuyButton) return;

	event.preventDefault();

	const form = quickBuyButton.closest('product-form')?.querySelector('form');
	if (!form) return;

	const variantId = form.querySelector('[name="id"]')?.value;
	const quantity = form.querySelector('[name="quantity"]')?.value || 1;
	const sellingPlan = form.querySelector('[name="selling_plan"]')?.value || null;

	const body = {
		items: [
			{
				id: variantId,
				quantity: quantity
			}
		]
	};

	if (sellingPlan) {
		body.items[0].selling_plan = sellingPlan;
	}

	try {
		const res = await fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body)
		});

		if (!res.ok) throw new Error('Cart add failed');

		const cartItem = await res.json();

		window.location.href = '/checkout';
	} catch (err) {
		console.error('❌ Error adding to cart:', err);
	}
});